module.exports = "pegasus_template/assets/blocks/image-5-tech.png";